import { render, staticRenderFns } from "./MainSwitch.vue?vue&type=template&id=39c43892&scoped=true"
import script from "./MainSwitch.vue?vue&type=script&lang=js"
export * from "./MainSwitch.vue?vue&type=script&lang=js"
import style0 from "./MainSwitch.vue?vue&type=style&index=0&id=39c43892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c43892",
  null
  
)

export default component.exports